import { render, staticRenderFns } from "./commodity.vue?vue&type=template&id=68fbb618&scoped=true&"
import script from "./commodity.vue?vue&type=script&lang=js&"
export * from "./commodity.vue?vue&type=script&lang=js&"
import style0 from "./commodity.vue?vue&type=style&index=0&id=68fbb618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fbb618",
  null
  
)

export default component.exports